import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Row, Col } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import { LanguageProvider } from '../../../core/language-provider';
import { ApiManager } from '../../../core/api-manager';



export default function DGSH_gyv_mrp_order_list({ data, setData, selectedRows, setSelectedRows, refreshData }) {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(null)
    const [showModal, setShowModal] = useState(null)
    const [rowReport, setRowReport] = useState(null)

    useEffect(() => {
        console.log('DATA', data)
    }, []);

    function openModal() {
        setShowModal(true)
    }

    function closeModal() {
        setShowModal(false)
    }


    /* async function createOrder(type) {
        setLoading(true)
        var rowSuccess = 0;
        var rowError = 0;
        var listRowError = [];
        for (var j = 0; j < data.length; j++) {
            var item = data[j]
            if (selectedRows.includes(item.id)) {
                console.log(item)
                var supplier_id = item.input_supplier ? item.input_supplier : item.supplier_id
                if (supplier_id) {
                    //se articolo ha fornitore
                    let constraints = [
                        { fieldName: "status", type: "value", value: "0_DRAFT" },
                        { fieldName: "idSupplier", type: "value", value: supplier_id },
                        { fieldName: "typeOrder", type: "value", value: type }
                    ]
                    var sorting = {
                        'field': 'id',
                        'order': 'desc'
                    }
                    var response = await DataManager.searchItems('supplier_order', 1, 1, sorting, '', {}, constraints)
                    console.warn('supplier_order', response)
                    if (response.success === 1) {
                        var supplierOrderId = null

                        if (response.body.length > 0) {
                            console.log('ordine fornitore trovato in bozza')
                            supplierOrderId = response.body[0].id
                        }
                        else {
                            var responseSupplier = await DataManager.getItem('supplier', supplier_id);

                            console.log('creo nuovo ordine fornitore')
                            if (responseSupplier.body[0].idPaymentCondition) {
                                var idPayment = null;
                                idPayment = responseSupplier.body[0].idPaymentCondition.id;

                                var el = {
                                    idSupplier: { id: supplier_id },
                                    status: { value: '0_DRAFT' },
                                    idPaymentCondition: { id: idPayment },
                                    orderDate: moment().format('YYYY-MM-DD'),
                                    typeOrder: { value: type }
                                }
                            } else {
                                var el = {
                                    idSupplier: { id: supplier_id },
                                    status: { value: '0_DRAFT' },
                                    orderDate: moment().format('YYYY-MM-DD'),
                                    typeOrder: { value: type }
                                }
                            }

                            var response2 = await DataManager.insertItem('supplier_order', el);
                            if (response2.success === 1) {
                                supplierOrderId = response2.id
                            }
                            else {
                                toast("Non è stato possibile creare un nuovo ordine fornitore.", { type: "error", position: "bottom-right", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, autoClose: 3000, theme: "dark" });
                                return
                            }
                        }

                        if (supplierOrderId) {

                            var resItemModel = await DataManager.getItem('item_model', item.idItemModel);
                            console.log(resItemModel);
                            var deliveryDate;
                            if (resItemModel.body[0].deliveryTime !== null) {
                                deliveryDate = moment().add(resItemModel.body[0].deliveryTime, 'weeks').format('YYYY-MM-DD');
                            } else {
                                deliveryDate = null
                            }

                            let constraints1 = [
                                { fieldName: "idItemModel", type: "value", value: item.idItemModel },
                                { fieldName: "idSupplier", type: "value", value: supplier_id },
                                { fieldName: "active", type: "value", value: 1 }
                            ]
                            var sorting1 = {
                                'field': 'id',
                                'order': 'desc'
                            }
                            var r1 = await DataManager.searchItems('item_model_suppliers', 1, 1, sorting1, '', {}, constraints1)
                            if (r1.success === 1 && r1.body.length > 0) {
                                var el2 = {
                                    idSupplierOrder: supplierOrderId,
                                    idItemModelSupplier: { id: r1.body[0].id },
                                    expectedDate: deliveryDate,
                                    idItemModel: { id: item.idItemModel },
                                    name: item.item_model_name,
                                    measureUnit: item.measureUnit,
                                    quantity: item.input_qta ? item.input_qta : item.requested_quantity,
                                    receivedQuantity: 0,
                                    leadtime: r1.body[0].leadtime,
                                    price: r1.body[0].price,
                                    status: { value: '0_PENDING' },
                                    idVatCondition: { id: resItemModel.body[0].idVatCondition.id },
                                    packages: parseFloat(resItemModel.body[0].quantityPackages) * parseFloat(item.input_qta ? item.input_qta : item.requested_quantity),
                                    totalRow: parseFloat(r1.body[0].price) * parseFloat(item.input_qta ? item.input_qta : item.requested_quantity),
                                    totalIva: parseFloat(r1.body[0].price) * parseFloat(item.input_qta ? item.input_qta : item.requested_quantity) * (resItemModel.body[0].idVatCondition.percentage) / 100,
                                    total: (parseFloat(r1.body[0].price) * parseFloat(item.input_qta ? item.input_qta : item.requested_quantity)) + (parseFloat(r1.body[0].price) * parseFloat(item.input_qta ? item.input_qta : item.requested_quantity) * (resItemModel.body[0].idVatCondition.percentage) / 100)
                                }
                                console.log(el2)
                                var response3 = await DataManager.insertItem('supplier_order_rows', el2);
                                if (response3.success === 1) {
                                    rowSuccess++;
                                    toast("Riga aggiunta con successo all'ordine fornitore.", { type: "success", position: "bottom-right", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, autoClose: 3000, theme: "dark" });
                                }
                                else {
                                    rowError++;
                                    listRowError.push({ 'itemModel': item.item_model_code, 'message': "Non è stato possibile aggiungere la riga all'ordine fornitore" })
                                    toast("Non è stato possibile aggiungere la riga all'ordine fornitore.", { type: "error", position: "bottom-right", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, autoClose: 3000, theme: "dark" });
                                }
                            }
                        }
                    }
                }
                else {
                    rowError++;
                    listRowError.push({ 'itemModel': item.item_model_code, 'message': "L'articolo non ha nessun fornitore." })
                    toast("L'articolo " + item.item_model_code + " non ha alcun fornitore.", { type: "error", position: "bottom-right", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, autoClose: 3000, theme: "dark" });
                }
            }
        }
        const a = {
            'success': rowSuccess,
            'error': rowError,
            'listError': listRowError,
        }
        console.log(a)
        setRowReport(a)
        openModal()
        setLoading(false)
        refreshData();
    } */


    async function createOrderB(type) {
        setLoading(true)

        var constraints = [{ fieldName: "author", type: "isnull" },
        { fieldName: "filters", type: "isnull" }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res1 = await DataManager.searchItems('gyt_order_list_request', 1, 1, sorting, '', [], constraints);
        if (res1.success === 1) {
            if (res1.body[0].finishDate) {
                var payload = {
                    typeOrder: type,
                    data: data,
                    selectedRows: selectedRows
                }
                var res = await ApiManager.sendAuthenticatedRequest('/custom/create_supplier_orders_from_selection', payload);
                console.log(res)
                let report = null;

                if (res && res.body && (res.body.success !== undefined || res.body.error !== undefined || res.body.listError !== undefined)) {
                    report = res.body;
                } else if (res && (res.success !== undefined || res.error !== undefined || res.listError !== undefined)) {
                    report = res;
                }

                if (report) {
                    const a = {
                        success: report.success || 0,
                        error: report.error || 0,
                        listError: report.listError || [],
                    };
                    setRowReport(a);
                    openModal();
                } else {
                    if (res && res.success === 1) {
                        toast("Ordini fornitore creati con successo.", { type: "success", position: "bottom-right", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, autoClose: 3000, theme: "dark" });
                    } else {
                        toast(res && res.message ? res.message : "Errore nella creazione degli ordini fornitore.", { type: "error", position: "bottom-right", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, autoClose: 3000, theme: "dark" });
                    }
                }

                setLoading(false)
                refreshData();

            } else {
                toast.error("MRP in corso...non è possible creare ordini.", { theme: 'colored' })
                setLoading(false)
            }
        }
    }


    return (
        <>
            <Row className='mt-2'>
                <Col md={12} className='mb-2'><Button className='w-100' size='sm' variant='primary' onClick={() => createOrderB("0_CONTO_LAVORO")}>Crea ordine CONTO LAVORO</Button></Col>
                <Col md={12} className='mb-2'><Button className='w-100' size='sm' variant='secondary' onClick={() => createOrderB("5_MATERIA_PRIMA")}>Crea ordine MATERIA PRIMA</Button></Col>
                <Col md={12} className='mb-2'><Button className='w-100' size='sm' variant='warning' onClick={() => createOrderB("10_PRODUZIONE_INTERNA")}>Crea ordine PRODUZIONE INTERNA</Button></Col>
            </Row>


            <Modal show={loading}>
                <Modal.Body className='text-center m-auto'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </Modal.Body>
            </Modal>


            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Report caricamento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p className='text-success'>Righe inserite con successo: {rowReport && rowReport.success}</p>
                            <p className='text-danger'>Righe non inserite: {rowReport && rowReport.error}</p>
                            {rowReport && rowReport.listError && rowReport.listError.length > 0 ? <>
                                <Row>
                                    <Col>
                                        <h4>Messaggi di errore:</h4>
                                        <ul>
                                            {rowReport && rowReport.listError.map((item, i) => {
                                                return (<li key={i}>Articolo: <b>{item.itemModel}</b><br /> Errore: <b>{item.message}</b></li>)
                                            })}
                                        </ul>
                                    </Col>
                                </Row>
                            </> : null}
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};
